import { useEffect } from "react";
import SeccionSchool from "../components/School/SeccionSchool";
import Navbar from "../components/Navbar";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";

export function School() {
  const { t } = useTranslation();
  const pathByLang = t("seo.school.pathByLang", { returnObjects: true });

  useEffect(() => {
    localStorage.setItem("colorFooter", "blue");
    localStorage.setItem("colorNav", "color");
  }, []);

  return (
    <div>
      <Seo pageKey="school" pathByLang={pathByLang} />
      <Navbar />
      <SeccionSchool />
    </div>
  );
}
